module.exports = __webpack_public_path__ + "static/media/silke.e981f020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/contact/silke.png
// module id = 1491
// module chunks = 0